import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthShell } from "./AuthShell";
import { Btn, Field } from "@/components/ui-kit";
import { api, formatError } from "@/api";
import { CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [message, setMessage] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMessage(data.message);
      setSent(true);
    } catch (err) {
      setMessage(formatError(err.response?.data?.detail));
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Palauta salasana" subtitle="Syötä sähköpostiosoitteesi, niin lähetämme palautusohjeet." testid="forgot-password-page">
      {sent ? (
        <div className="space-y-6" data-testid="forgot-confirmation">
          <div className="flex items-start gap-3 rounded-xl border border-[#E6E1D9] bg-[#E9EAEC] p-4">
            <CheckCircle2 size={20} className="text-emerald-600 shrink-0 mt-0.5" />
            <p className="text-sm text-[#292827] leading-relaxed">{message}</p>
          </div>
          <Btn variant="outline" className="w-full" onClick={() => navigate("/kirjaudu")} data-testid="back-to-login">
            Takaisin kirjautumiseen
          </Btn>
        </div>
      ) : (
        <>
          <form onSubmit={submit} className="space-y-4">
            <Field label="Sähköposti" type="email" value={email} required
              onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
            <Btn type="submit" disabled={loading} className="w-full" data-testid="forgot-submit">
              {loading ? "Lähetetään..." : "Lähetä palautuslinkki"}
            </Btn>
          </form>
          <p className="mt-6 text-center text-sm text-[#6E675C]">
            <span className="font-medium text-[#292827] cursor-pointer hover:underline" onClick={() => navigate("/kirjaudu")} data-testid="to-login">
              Takaisin kirjautumiseen
            </span>
          </p>
        </>
      )}
    </AuthShell>
  );
}
